'use strict';
angular.module('schoolLinqApp').controller('reportsController', ['$scope', '$location', '$q', function ($scope, $location, $q) {}]);
